import _ from "lodash";
import { sumAll } from "../../../../utils/common-utils";
import { store } from "../../../../redux";
import {
  setCartInformation,
  setDeliveryAddressInformation,
  setDeliveryTypeInformation,
  setOrderInformation,
} from "../../../../redux/reducers/order/order-action";

export const getProductQuantity = (supplierCart, productDetails, material) => {
  let quantity = 0;

  if (!_.isEmpty(supplierCart)) {
    const cartItem = supplierCart.cartProducts.find(
      ({ product, containerMaterial }) =>
        product.id === productDetails.id && containerMaterial.id === material.id
    );

    if (cartItem) {
      quantity = cartItem.quantity;
    }
  }

  return quantity;
};

export const getOtherProductsQuantity = (
  supplierCart,
  productId,
  containerMaterialId
) => {
  let sum = 0;
  if (!_.isEmpty(supplierCart)) {
    const filteredProducts = otherProducts(
      supplierCart,
      productId,
      containerMaterialId
    );
    sum = sumAll(filteredProducts, "quantity");
  }

  return sum;
};

const filterVariableProducts = (
  cartProducts,
  productId,
  containerMaterialId,
  cartVolume
) => {
  return cartProducts.filter(
    ({ product, containerMaterial, volume }) =>
      product.id !== productId ||
      (product.id === productId &&
        containerMaterial.id !== containerMaterialId) ||
      (product.id === productId &&
        containerMaterial.id === containerMaterialId &&
        cartVolume !== volume)
  );
};

export const otherProducts = (
  { cartProducts },
  productId,
  containerMaterialId,
  cartVolume
) => {
  if (cartVolume) {
    const otherProducts = filterVariableProducts(
      cartProducts,
      productId,
      containerMaterialId,
      cartVolume
    );

    return otherProducts;
  } else {
    const otherProducts = cartProducts.filter(
      ({ product, containerMaterial, volume }) =>
        product.id !== productId ||
        (product.id === productId &&
          containerMaterial.id !== containerMaterialId &&
          product.containerOption.variableVolume &&
          cartVolume &&
          cartVolume !== volume)
    );

    return otherProducts;
  }
};

export const prepareOtherProductCart = (
  supplierCart,
  productId,
  materialId,
  volume
) => {
  const otherCartProducts = otherProducts(
    supplierCart,
    productId,
    materialId,
    volume
  );

  const cartItems = otherCartProducts.map((item) => ({
    productId: item.product.id,
    volume: item.volume,
    quantity: item.quantity,
    containerMaterialId: item.containerMaterial.id,
  }));

  return cartItems;
};

export const prepareUpdateCartRequest = (
  carts,
  product,
  quantity,
  materialId,
  volume
) => {
  const details = {
    productQuantities: [
      {
        quantity,
        productId: product.id,
        volume: product.volume,
        containerMaterialId: materialId,
      },
      ...(!_.isEmpty(carts)
        ? prepareOtherProductCart(carts, product.id, materialId, volume)
        : []),
    ],
  };

  return details;
};

export const newSupplierCartRequest = ({ product, materialId }) => {
  return {
    productQuantities: [
      {
        quantity: 1,
        productId: product.id,
        volume: product.volume,
        containerMaterialId: materialId,
      },
    ],
  };
};

export const emptyCartRequest = () => {
  return {
    productQuantities: [],
  };
};

export const updateStorageOnClearCart = (removeCart = true) => {
  const { dispatch } = store;
  removeCart && dispatch(setCartInformation({}));
  dispatch(setDeliveryTypeInformation(""));
  dispatch(setDeliveryAddressInformation(""));
  dispatch(setOrderInformation(""));
};

export const isDifferentSupplier = ({ cartProducts }, supplierId) => {
  const diffentSupplier = cartProducts.filter(
    ({ product }) => product.supplier.id !== supplierId
  ).length;

  return Boolean(diffentSupplier);
};
